import React from 'react';
import classnames from 'classnames';
import HostPortalActions from './HostPortalActions';
import DateTimePicker from 'react-datetime';
import TimePicker from '../../FormFields/TimePicker';
import AddressLoader from '../../Addresses/AddressLoader';
import Icon from 'svgIcon';
import Moment from 'moment';
import { SelectField, TextField } from '../../FormFields/formFields';

export default class PhysicalParty extends React.Component {
	constructor(props) {
        super(props);
		this.state = {};
		this.updatePartyDate = this.updatePartyDate.bind(this);
		this.updatePartyStartTime = this.updatePartyStartTime.bind(this);
		this.updatePartyEndTime = this.updatePartyEndTime.bind(this);
		this.isValidDay = this.isValidDay.bind(this);
		this.partyIsValid = this.partyIsValid.bind(this);
	}

	componentDidMount() {
		this.setState({
			startStartTimeLimit: '07:00',
			startEndTimeLimit: '23:00',
			endStartTimeLimit: '07:00',
			endEndTimeLimit: '23:00',
			endTimeDisabled: true,
			step: 15,
			unsureCheckbox: false,
			timeZone: ''
		});
		HostPortalActions.changeField('NewPartyDate', new Moment().format('L'));
	}

	showCalendar() {
		this.refs.NewPartyDate.setState({open: true});
	}

	updatePartyDate(value) {
		HostPortalActions.changeField('NewPartyDate', value.format('L'));
	}

	updatePartyStartTime(value) {
		if (value !== '' && value !== 'None') {
			let newTime = new Moment(value, ['H:m', 'h:m a']).add(this.state.step, 'm').format("LT");
			this.setState({
				endTimeDisabled: false,
				endStartTimeLimit: newTime
			});
		} else {
			this.setState({
				endTimeDisabled: true,
				endStartTimeLimit: "07:00",
			});
			HostPortalActions.changeField('endTime', '');
		}
		HostPortalActions.changeField('startTime', value);
		//attempt to determine tomezone if there is a start time, otherwise go back to 'Select Time Zone...'
		if (value === '' || value === 'None') {
			//this is a hack but found no other way around it - disabled selects won't respond to changes.
			document.getElementById('TimeZone').value = '';
			HostPortalActions.changeField('timeZone', value);
		} else {
			var browserTZ = this.props.timeZoneList.find(tz => tz.code === Intl.DateTimeFormat().resolvedOptions().timeZone);
			var tzCode = typeof (browserTZ) !== 'undefined' ? browserTZ.code : '';
			HostPortalActions.changeField('timeZone', tzCode);
		}
	}

	updatePartyEndTime(value) {
		if (value !== '' && value !== 'None') {
			let newTime = new Moment(value, ['H:m', 'h:m a']).subtract(this.state.step, 'm').format("LT");
			this.setState({
				startEndTimeLimit: newTime
			});
		} else {
			this.setState({
				startstartTimeLimit: '07:00',
				startEndTimeLimit: '23:00'
			});
		}
		HostPortalActions.changeField('endTime', value);
	}

	isValidDay(current) {
		let yesterday = Moment().subtract(1, 'day');
		return current.isAfter(yesterday);
	}

	showHideLocation() {
		this.setState({unsureCheckbox: this.refs.unsureCheckbox.checked});
	}


	submitPartyRequest() {
		let NewPartyLocation = this.props.NewPartyLocation;
		if (!this.state.unsureCheckbox && !this.refs.adrloader.isValidAddress()) {
			this.refs.adrloader.registerErrors();
			return false;
		} else if (!this.state.unsureCheckbox) {
			NewPartyLocation = this.refs.adrloader.getAddressValues();
		}
		//find the timezone description for the email
		var tz = this.props.timeZoneList.find(item => { return item.code === this.props.timeZone });
		//shape data
		let eventData = {
			EventType: this.props.selectedTheme,
			Title: this.props.NewPartyTitle,
			Date: this.props.NewPartyDate,
			StartTime: this.props.startTime,
			EndTime: this.props.endTime,
			Location: NewPartyLocation,
			TimeZone: tz.description
		};
		HostPortalActions.requestPhysicalParty(eventData);
	}
	handleTimeZoneChange(name, value) {
		HostPortalActions.changeField('timeZone', value);
	}

	partyIsValid() {
		if (this.props.NewPartyTitle.length === 0) {
			return false;
		}
		if (this.refs.adrloader === null) {
			return true;
		}
	}

	render() {
		let validationRules = {
			NewPartyTitle: {
				required: true,
				maxLength: 100,
				requiredMessage: window.jenkon.resources["PWS.MyAccount.PartyTitleRequired"],
			},
			TimeZone: {
				required: (this.props.startTime !== '' && this.props.startTime !== 'None') ? true : false,
			}
		};
		let CalendarData = {
			Size: 14,
			Fill: "#333333",
			name: "Calendar"
		};
		return (
            <div className="animate-in">
                <div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyTitle"]}</div>
                <TextField
		ref="NewPartyTitle"
		name="NewPartyTitle"
		value={this.props.NewPartyTitle}
		handleChange={HostPortalActions.changeField}
		Rules={validationRules.NewPartyTitle}
		maxLength = {100}
		label={window.jenkon.resources["PWS.MyAccount.PartyTitlePlaceholder"]}
		classes="form-control input-100 input-bordered clearable"
	/>
	<div className="spacer12"></div>
	<div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyDateAndTime"]}</div>
		<div id="dateField" className="input-group date input-25 required-field">
		<DateTimePicker ref="NewPartyDate" locale={this.props.userCulture} defaultValue={this.props.NewPartyDate} isValidDate={this.isValidDay} onChange={this.updatePartyDate} closeOnSelect={true} timeFormat={false} inputProps={{readOnly: true}} />
		<span className="input-group-addon" onClick={() => this.showCalendar()} ><Icon iconData={CalendarData} inline={true} /></span>
	</div>
	<div className="input-group time input-25">
		<TimePicker startTime={this.state.startStartTimeLimit} endTime={this.state.startEndTimeLimit} value={this.props.startTime} onChange={this.updatePartyStartTime} placeholder={window.jenkon.resources['PWS.MyAccount.AddAStartTime']} local={this.props.userCulture} step={this.state.step} />
	</div>
	<div className="input-group time input-25">
		<TimePicker
			startTime={this.state.endStartTimeLimit}
			endTime={this.state.endEndTimeLimit}
			value={this.props.endTime}
			disabled={this.state.endTimeDisabled}
			onChange={this.updatePartyEndTime}
			placeholder={window.jenkon.resources['PWS.MyAccount.AddAnEndTime']}
			local={this.props.userCulture}
			step={this.state.step} />
	</div>
	<div className="input-group time input-25">
		<SelectField
			ref="TimeZone"
			name="TimeZone"
			handleChange={this.handleTimeZoneChange.bind(this)}
			optionData={this.props.timeZoneList}
			keys={{ valueKey: 'code', nameKey: 'description' }}
			showEmptyOption={this.props.timeZone === '' || this.props.timeZone === 'None'}
			label="Select Time Zone"
			disabled={this.props.startTime === '' || this.props.startTime === 'None'}
			Rules={validationRules.TimeZone}
			value={this.props.timeZone}
			classes="input-60"
		/>
	</div>
	<div className="spacer12"></div>
	<div className="simpleHR"></div>
	<div className="spacer12"></div>
	<div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyLocation"]}
		<div className="addressUnknown">
			<input type="checkbox" ref="unsureCheckbox" name="locationUnknown" onChange={this.showHideLocation.bind(this)} defaultChecked={this.state.unsureCheckbox} /><label style={{fontWeight: "normal"}}>&nbsp;{window.jenkon.resources['PWS.MyAccount.ImNotSureYet']}</label>
		</div>
	</div>
	<div className={classnames({"visuallyhidden": this.state.unsureCheckbox})}>
		<AddressLoader ref="adrloader" countryCode={this.props.Country || window.jenkon.country} schema="Default" initialValues={this.props.NewPartyLocation} />
	</div>
	<div className="spacer12"></div>
	<div className="spacer12"></div>
	<div className="continue-button-container">
		<div className="required-field-legend"> = {this.props.resources["PWS.Globals.Required"]}</div>
		<button className={classnames("basic-submit-button", {"disabled": this.props.NewPartyTitle.length === 0})} disabled={this.props.NewPartyTitle.length === 0} onClick={this.submitPartyRequest.bind(this)}>{this.props.resources["PWS.MyAccount.SendEmailRequest"]}</button>
	</div>
</div>

        );
}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/PhysicalParty.js